<template>
  <qc-container title="租赁合同">
    <page-request ref="table" url="/api/mgr/business/contract/list" :table-header="tableHeader" :expend="expend" :op-width="200">
      <t-button  @click="doEdit()">添加</t-button>
      <template #op="scope">
        <b-button v-show="scope.row.status===0" @click="doEdit(scope.row)">编辑</b-button>
        <b-button v-show="scope.row.status===0"  @click="activeContract(scope.row)">启用</b-button>
        <b-button v-show="scope.row.status===0" @click="doDel(scope.row)">删除</b-button>
        <b-button v-show="scope.row.status!==0" @click="toDetail(scope.row)">查看</b-button>
        <b-button @click="showDetail(scope.row)">查看合同</b-button>
      </template>
    </page-request>
    <open-contract ref="openContract"></open-contract>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container";
import PageRequest from "/src/components/base/page-request";
import TButton from "/src/components/el/t-button";
import BButton from "/src/components/el/b-button";
import OpenContract from "@view/lease/contract/open-contract.vue";


export default {
  name: 'contract_list',
  components: {OpenContract, QcContainer, PageRequest,TButton,BButton},
  data () {
    return {
      tableHeader: [
        {prop: "name", label: "合同名称"},
        {prop: "version", label: "版本",width:100},
        {prop: "statusDesc", label: "状态",width:100},
        {prop: "remark", label: "说明",width:200},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend:[
        {label: "合同名称", prop: "name"},
        {label:"状态",prop:"status",type:"dict",dictType:"contractStatus"}
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    showDetail(row){
      this.$refs.openContract.open(row);
    },
    toDetail(row){
      this.toRouter("/index/lease/contract/detail",{id:row.id});
    },
    doEdit(row){
      this.toRouter("/index/lease/contract/add",row?{id:row.id}:{});
    },
    doDel(row){
      this.msgConfirm("/api/mgr/business/contract/delete",{id:row.id},()=>{
        this.pageReloadData();
      });
    },
    activeContract(row){
      this.msgConfirm("/api/mgr/business/contract/activeContract",{id:row.id},()=>{
        this.pageReloadData();
      },"您确定要启用该合同吗？")
    }
  },
  mounted () {

  }
}
</script>


<style lang="less" scoped>

</style>
